import { render } from "./identification-start.vue?vue&type=template&id=11ff886b&scoped=true&ts=true"
import script from "./identification-start.vue?vue&type=script&lang=ts"
export * from "./identification-start.vue?vue&type=script&lang=ts"

import "./identification-start.vue?vue&type=style&index=0&id=11ff886b&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ff886b"]])

export default __exports__